import { render } from "./NotesList.vue?vue&type=template&id=971bedea&scoped=true"
import script from "./NotesList.vue?vue&type=script&lang=js"
export * from "./NotesList.vue?vue&type=script&lang=js"

import "./NotesList.vue?vue&type=style&index=0&id=971bedea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971bedea"]])

export default __exports__